import type { ChannelDto } from '@lagerfeuer/shared';

/** App-Pfade an einer Stelle (Sprung zu Nachrichten über `?message=<id>`). */
export const paths = {
  home: () => '/channels/@me',
  dm: (channelId: string, messageId?: string) => withMessage(`/channels/@me/${channelId}`, messageId),
  channel: (serverId: string, channelId: string, messageId?: string) => withMessage(`/channels/${serverId}/${channelId}`, messageId),
  server: (serverId: string) => `/channels/${serverId}`,
  invite: (code: string) => `/invite/${encodeURIComponent(code)}`,
  settings: (tab = 'konto') => `/settings/${tab}`,
  serverSettings: (serverId: string, tab = 'uebersicht') => `/servers/${serverId}/settings/${tab}`,
  channelSettings: (channelId: string, tab = 'uebersicht') => `/channel-settings/${channelId}/${tab}`,
  login: () => '/login',
};

function withMessage(base: string, messageId?: string): string {
  return messageId ? `${base}?message=${encodeURIComponent(messageId)}` : base;
}

/**
 * Pfad zu einem Kanal. Threads öffnen im Seitenpanel des Elternkanals (`?thread=`), Forenbeiträge ebenso.
 */
export function pathForChannel(ch: Pick<ChannelDto, 'id' | 'serverId' | 'type' | 'parentId'>, messageId?: string): string {
  if (!ch.serverId) return paths.dm(ch.id, messageId);
  if ((ch.type === 'PUBLIC_THREAD' || ch.type === 'PRIVATE_THREAD') && ch.parentId) {
    const qs = new URLSearchParams({ thread: ch.id });
    if (messageId) qs.set('message', messageId);
    return `/channels/${ch.serverId}/${ch.parentId}?${qs.toString()}`;
  }
  return paths.channel(ch.serverId, ch.id, messageId);
}

/** Einladungslink zum Teilen (absolut). */
export function inviteUrl(code: string): string {
  return `${window.location.origin}${paths.invite(code)}`;
}
